const Customer = {

    // FIELDS
    "fname": "First Name",
    "lname": "Last Name",
    "gender": "Gender",
    "dob": "Date of Birth",
    "status": "Status",
    "mobile": "Mobile Number",
    "email": "Email",
    "password": "Password",
    "new_password": "New Password",
    "confirm_password": "Confirm Password",
    "profile": "Profile Photo",
    "district": "District",
    "address": "Address",

    "search": "Search",

    // PAGE HEADER
    "customer": "Customer",
    "update_password": "Update Password",

    // TOAST
    "success_updated": "Updated Successfully",

    // ERROR
    "error_fname": "Enter First Name",
    "error_lname": "Enter Last Name",
    "error_gender": "Select Gender",
    "error_dob": "Choose Date of Birth",
    "error_status": "Select Status",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",
    "error_email": "Enter Email",
    "error_password": "Enter Password",
    "error_new_password": "Enter New Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_pass_match": "Confirm Password doesn't match",
    "error_profile": "Choose Profile Photo",
    "error_district": "Select District",
    "error_address": "Enter Address",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_email": 'EMAIL',
    "table_mobile": 'MOBILE',
    "table_district": 'DISTRICT',
    "table_status": "STATUS",

}

export default Customer;